import { makeAutoObservable } from "mobx";

class ConversionRates {
  rates: Record<string, string> = {};
  isLoaded = false;

  constructor() {
    makeAutoObservable(this);
  }

  setRates(rates: Record<string, string>): void {
    this.rates = rates;
    this.isLoaded = true;
  }

  getRate(currency: string): string | undefined {
    return this.rates[currency];
  }
}

export default ConversionRates;
